import { palette } from './palette'

export const colors = {
  // Text colors
  text: palette.gray[900],
  textSecondary: palette.gray[600],
  placeholder: palette.gray[400],
  label: palette.gray[800],

  // Background colors
  background: palette.gray[50],
  white: palette.white,

  // Border colors
  border: palette.gray[200],

  // Brand colors
  primary: palette.primary[400],

  // Semantic colors
  danger: palette.sub.red[500],
  success: palette.sub.mint[400],
  warning: palette.sub.yellow[400],
} as const

export type Colors = typeof colors
export type ColorKey = keyof Colors
